import React from 'react';
import TranslationHelper from '../../../../../../helpers/TranslationHelper';
import CollapseItem from '../../../../../../components/collapseItem';
import { ListItem } from './ListItem';

const ReportsSectionContent = ({
    assignedReports,
}: {
    assignedReports?: string;
}) => {
    return (
        <ListItem
            label={TranslationHelper.translate('Assigned reports')}
            value={assignedReports ?? ''}
        />
    );
};

type Props = {
    reportNames: string;
};

export const ReportsSection = ({ reportNames }: Props) => {
    return (
        <CollapseItem
            title={TranslationHelper.translate('Reports')}
            content={<ReportsSectionContent assignedReports={reportNames} />}
            collapsed={false}
        />
    );
};
